export default [
  {
    tags: ['backend', 'frontend', 'application', 'design' ],
    labels: [ 'REACT', 'REDUX', 'PSQL', 'PYTHON'],
    imageUrl: 'images/carbos.png',
    name: 'Carbos',
    description: 'Carbos was a project to leverage the Ethereum blockchain to increase access and accountability in carbon trading markets.',
    links: [
      {
        to: 'https://github.com/carbos-workshop',
        type: 'github',
        // text: 'view code'
      },
      {
        to: 'http://carbos.co/',
        type: 'site',
        // text: 'visit site',
        inactive: true,
      },
    ]
  },
  {
    tags: ['frontend', 'backend', 'website'],
    labels: ['REACT', 'AWS', 'MATERIAL', 'SKETCH', ],
    imageUrl: 'images/nathan.tutchton.rocks.png',
    name: 'This Site',
    description: 'My personal site. Comletely serverless, with auto-magical builds, deployments, and static hosting from an S3 bucket.',
    links: [
      {
        to: 'https://github.com/ntutchton/nathan.tutchton.rocks',
        type: 'github',
        // text: 'view code'
      },
    ]
  },
  {
    tags: [ 'application', 'frontend'],
    labels: [ 'ANGULAR', 'NODE', 'MONGO', 'DOCKER', ],
    imageUrl: 'images/SServ.png',
    name: 'GEOINT Self Service',
    description: 'A tool to provision and permission DevOps resources across NGA (National Geospacial Administration) and NGA contractor networks.',
    links: [
      {
        to: 'https://gitlab.devops.geointservices.io/SelfService2/selfservice2',
        type: 'gitlab',
        // text: 'view code',
        warning: 'You will need NGA login credentials to view this content.',
      },
      {
        to: 'https://my.gs.mil/login',
        type: 'site',
        // text: 'visit site',
        warning: 'You will need NGA login credentials to view this content.',
      },
    ]
  },
  {
    tags: [ 'application', 'frontend', 'backend' ],
    labels: [ 'SWIFT', 'ILLUSTRATOR', 'INVISION', 'AWS', ],
    imageUrl: 'images/Klovis.png',
    name: 'Klovis',
    description: 'The continuation of my work on Carbos, Klovis is an in-the-works iOS application that empowers users to take contol of their carbon footprint.',
    links: [
      {
        to: 'http://klovis.io/',
        type: 'site',
        // text: 'visit site',
        inactive: true,
      },
    ]
  },
  {
    tags: ['design'],
    labels: ['SKETCH' ],
    name: 'FUTHARK App Icons',
    description: "A small library of runic app icons I used to give my iphone's home screen a makeover.",
    imageUrl: 'images/FUTHARK.png',
    links: [
      {
        to: '#',
        type: 'sketch',
        // text: 'see it',
      },
    ]
  },
  // {
  //   tags: ['design'],
  //   labels: ['PHOTOSHOP', 'ILLUSTRATOR', ],
  //   imageUrl: '',
  //   name: 'Scapegoat',
  //   description: 'I like to draw. Sometimes I draw digitally.',
  //   links: [
  //     {
  //       to: '#',
  //       type: 'dribbble',
  //       // text: 'see it',
  //     },
  //   ]
  // },
  // {
  //   tags: ['backend'],
  //   labels: ['PYTHON', ],
  //   imageUrl: 'images/OSRS.png',
  //   name: 'Mr Clicky',
  //   description: 'A simple bot for training skills in "Old School" Runescape.',
  //   links: [
  //     {
  //       to: 'https://github.com/ntutchton/mr-clicky',
  //       type: 'github',
  //       // text: 'view code'
  //     },
  //   ]
  // },
]



// WEBPACK FOOTER //
// ./src/components/Main/Projects/projectInfo.js